var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Button, Dimmer, Form, Input, Loader, Message } from "semantic-ui-react";
import ErrorDisplay from "../ErrorDisplay";
import FieldWithErrorDisplay from "../FieldWithErrorDisplay";
import { formatMonetaryDecimal } from "../kit/rna-fish/EditKitForm";
import { postJsonWithAuthn } from "../RequestHelpers";
var AddShipmentTrackingModal = /** @class */ (function (_super) {
    __extends(AddShipmentTrackingModal, _super);
    function AddShipmentTrackingModal(props) {
        var _this = _super.call(this, props) || this;
        _this.onShippingCostChange = function (event) {
            var cents = parseMonetaryInput(event.currentTarget.value);
            _this.setState(function (oldState) {
                var filtered = oldState.errors.filter(function (e) { return e.path !== '/shippingCostCents'; });
                if (cents !== undefined) {
                    return {
                        errors: filtered,
                        shippingCostCents: cents
                    };
                }
                else {
                    return {
                        errors: filtered.concat({ msg: 'Invalid cost', path: '/shippingCostCents' }),
                        shippingCostCents: oldState.shippingCostCents
                    };
                }
            });
        };
        _this.onTrackingChange = function (event, data) {
            var str = data.value;
            _this.setState({ tracking: str });
        };
        _this.onNoteChange = function (event, data) {
            var str = data.value;
            _this.setState({ note: str });
        };
        _this.submit = function () {
            _this.setState({
                loading: true,
                success: false,
            }, function () {
                postJsonWithAuthn("/admin/orders/id/" + encodeURIComponent(_this.props.orderId) + "/shipments/id/" + encodeURIComponent(_this.props.shipmentId) + "/tracking", JSON.stringify({
                    tracking: _this.state.tracking,
                    shippingCostCents: _this.state.shippingCostCents,
                    note: _this.state.note
                }))
                    .then(function (resp) {
                    if (resp.ok) {
                        _this.setState({
                            loading: false,
                            success: true,
                            errors: []
                        });
                        return;
                    }
                    else if (resp.status === 400) {
                        return resp.json();
                    }
                    else {
                        _this.setState({
                            loading: false,
                            success: false,
                            errors: [{
                                    path: '/',
                                    msg: 'An unexpected error occurred'
                                }]
                        });
                        return;
                    }
                })
                    .then(function (resp) {
                    if (resp !== undefined) {
                        _this.setState({
                            errors: resp.errors,
                            loading: false,
                            success: false
                        });
                    }
                }).catch(function (rej) {
                    console.error("Couldn't add tracking: " + rej);
                });
            });
        };
        _this.state = {
            loading: false,
            success: false,
            errors: [],
            shippingCostCents: 0,
            tracking: '',
            note: ''
        };
        return _this;
    }
    AddShipmentTrackingModal.prototype.render = function () {
        return React.createElement(Dimmer.Dimmable, { as: Form, error: this.state.errors.length > 0 },
            React.createElement(Dimmer, { active: this.state.loading, inverted: true },
                React.createElement(Loader, null)),
            React.createElement(FieldWithErrorDisplay, { errors: this.state.errors, errorPath: '/tracking', labelContent: React.createElement(React.Fragment, null, "Tracking info") },
                React.createElement(Input, { onChange: this.onTrackingChange, value: this.state.tracking })),
            React.createElement(FieldWithErrorDisplay, { errors: this.state.errors, errorPath: '/shippingCostCents', labelContent: React.createElement(React.Fragment, null, "Shipping cost") },
                React.createElement(Input, { onChange: this.onShippingCostChange }),
                React.createElement("div", { style: { color: 'grey' } },
                    "\u2937 Parsed as: $",
                    formatMonetaryDecimal(this.state.shippingCostCents))),
            React.createElement(FieldWithErrorDisplay, { errors: this.state.errors, errorPath: '/note', labelContent: React.createElement(React.Fragment, null, "Note") },
                React.createElement(Input, { onChange: this.onNoteChange, value: this.state.note })),
            this.state.success &&
                React.createElement(Message, { positive: true }, "Shipment updated."),
            React.createElement(ErrorDisplay, { errors: this.state.errors, errorPath: '/' }),
            React.createElement(Button, { disabled: this.state.success, icon: 'shipping', label: 'Add tracking info', labelPosition: 'left', onClick: this.submit, positive: true }));
    };
    return AddShipmentTrackingModal;
}(React.PureComponent));
export default AddShipmentTrackingModal;
;
export var parseMonetaryInput = function (str) {
    var chunks = str.split('.');
    var dollars = Number(chunks[0]);
    var valid = true;
    if (isNaN(dollars)) {
        valid = false;
    }
    var cents = 0;
    if (chunks.length > 1) {
        if (chunks[1].length > 2) {
            valid = false;
        }
        else {
            var centsStr = chunks[1];
            while (centsStr.length < 2) {
                centsStr = centsStr + "0";
            }
            cents = Number(centsStr);
            if (isNaN(cents)) {
                valid = false;
            }
            cents *= Math.sign(dollars);
        }
    }
    if (valid) {
        return dollars * 100 + cents;
    }
    return undefined;
};
//# sourceMappingURL=AddOrderShipmentTracking.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/AddOrderShipmentTracking.js
// module id = 284
// module chunks = 0